import { Text } from '@chakra-ui/react'

import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'

export default function CustomFormTextAnswer() {
  const { answer } = useCustomFormAnswer()

  return (
    <CustomFormEmptyAnswerFeedback>
      <Text color="primary">{answer.answer && answer.answer[0]}</Text>
    </CustomFormEmptyAnswerFeedback>
  )
}
